import React from 'react';
import { Link } from 'react-router-dom';
import PagedEntitiesList from '../../common/components/PagedEntitiesList';
import NewButton from '../../common/components/NewButton';
import { withTranslation } from 'react-i18next';
import ui from '../../common/services/ui';
import { Panel } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-regular-svg-icons';

const List = ({ t, parentId, ...rest }) => {
	const columns = [
		{
			header: t('Child_FullName'),
			accessor: 'fullName',
			sortable: true
		},
		{
			header: t('Child_DateOfBirth'),
			accessor: 'dateOfBirth',
			cell: (dateOfBirth) => (ui.formatDate(dateOfBirth))
		},
		{
			header: t('Child_IsDeleted'),
			accessor: 'isDeleted',
			sortable: true,
			cell: (isDeleted) => (ui.formatBoolean(isDeleted))
		},
		{
			header: t('Common_Actions'),
			accessor: 'id',
			cell: (id) => <Link to={`/parents/${parentId}/children/${id}`} className='btn btn-teal'><FontAwesomeIcon icon={faEdit} /> {t('Common_Edit')}</Link>
		}
	];

	return <Panel>
		<Panel.Body>
			<PagedEntitiesList columns={columns} listActions={<NewButton newItemPath={`/parents/${parentId}/children/new`} />} {...rest} />
		</Panel.Body>
	</Panel>;
};

export default withTranslation()(List);